import { SocialType } from '../typings/common-types';

declare global {
  interface Window {
    twttr: any;
    instgrm: {
      Embeds: {
        process: Function;
      };
    };
  }
}

export const getSocialUrlParsed = (src: string, socialType?: SocialType): string => {
  if (!socialType) {
    return src;
  }
  const srcFacebook = socialType === 'facebook' ? src?.split('href=')[1]?.split('&')[0] || '' : '';
  const decodedSrcFacebook = decodeURIComponent(srcFacebook);
  const srcParsed = socialType === 'facebook' ? decodedSrcFacebook : src;
  return srcParsed;
};

// Instagram code is
export const getInstagramShortCode = (url: string): string => {
  const regExp = /https?:\/\/www\.?instagram\.com\S*?\/[^/?#&]+\/(\S{11})\/?/;
  const match = url.match(regExp);
  return match?.[1] || '';
};

export const getYoutubeVideoiId = (url: string): string => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match?.[7].length === 11 ? match[7] : '';
};

export const getTweetId = (url: string): string => {
  const regExp = /https?:\/\/(?:www\.)?(?:twitter\.com|x\.com)\/\w+\/status\/(\d{10,19})\S*/;
  const match = url.match(regExp);
  return match?.[1] || '';
};

/**
 *  Twitter embed script support funcion
 *
 * @param d Specifies a frame's [browser APIs](https://developer.mozilla.org/en-US/docs/Web/API) such as `window` and `document`.
 * @param id html element id
 */
export const addTwitterScript = () => {
  window.twttr = ((d, id) => {
    const fjs = d.getElementsByTagName('script')[0];
    const t = window.twttr || {};
    if (d.getElementById(id)) {
      return t;
    }
    const js = d.createElement('script') as HTMLScriptElement;
    js.id = id;
    js.src = 'https://platform.twitter.com/widgets.js';
    fjs.parentNode?.insertBefore(js, fjs);

    t._e = [];
    t.ready = (f: any) => {
      t._e.push(f);
    };

    return t;
  })(document, 'twitter-wjs');
  window?.twttr?.widgets?.load();
};

/**
 *  Instragram embed script support funcion
 *
 * @param frm Specifies a frame's [browser APIs](https://developer.mozilla.org/en-US/docs/Web/API) such as `window` and `document`.
 * @param id html element id
 */
export const addInstagramScript = () => {
  window.instgrm = ((frm, id) => {
    const fjs = frm.getElementsByTagName('script')[0];
    const t = window.instgrm;

    if (frm.getElementById(id)) {
      return t;
    }

    const scriptElement = frm.createElement('script') as HTMLScriptElement;
    scriptElement.setAttribute('async', '');
    scriptElement.setAttribute('id', id);
    scriptElement.setAttribute('src', 'https://www.instagram.com/embed.js');
    fjs.parentNode?.insertBefore(scriptElement, fjs);

    return t;
  })(document, 'instagram-ejs');
  window?.instgrm?.Embeds?.process();
};
